import { render } from "./TitleForm.vue?vue&type=template&id=b4748ce4"
import script from "./TitleForm.vue?vue&type=script&lang=js"
export * from "./TitleForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__